<template> 
	<div class="inputTemplateWrapper">
		<slot name="inputIcon" v-if="hasIcon">inputIcon</slot>
        <slot name="inputLabel" v-if="hasLabel">inputLabel</slot>
		<slot name="inputEl">inputEl</slot>
		<slot name="inputBtn" v-if="hasButton">inputBtn</slot>
	</div>
</template>

<!-- do not bind styling directly to .inputTemplateWrapper, use compound css selectors to avoid affecting styling across components  -->

<script type="text/javascript">
	export default {
    name: 'inputTemplate',
    props: ['hasIcon', 'hasButton', 'hasLabel']
  }
</script>